<template>
	<div class="wrapper" @click="copy">
		<div class="content">{{ value }}</div>
		<CopyIcon class="icon" />
	</div>
</template>

<script setup lang="ts">
import CopyIcon from '@/assets/icons/copy.svg?component';
import { useTelegram } from '@/composables/useTelegram';

const props = defineProps<{
	value: any;
}>();

const { telegram } = useTelegram();

const copy = () => {
	if (props.value.toString) {
		navigator.clipboard.writeText(props.value.toString());
		telegram.WebApp.showAlert('Address copied to clipboard');
	}
};
</script>

<style scoped>
.wrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: var(--secondary-background-color);
	border-radius: var(--size-xs);
	padding: var(--size-s);
	justify-content: space-between;
	cursor: pointer;
}

.content {
	word-break: break-all;
}
</style>
